import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Menu, MenuItem, Stack } from "@mui/material";
import { MouseEvent, useState } from "react";
import Button from "./Styled/Button";

export default function ParentAssets({ config }: any) {
  const { assets, onClick, selectedAsset, assetNameFormatter } = config;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const formatAssetName = (asset: any) =>
    assetNameFormatter
      ? assetNameFormatter(asset)
      : asset.asset_name.split(" ").slice(1).join(" ");

  return (
    <Stack spacing={1} direction="row" height="100%">
      {assets.slice(0, 4).map((asset: any) => (
        <Button
          variant="outlined"
          onClick={(event: MouseEvent<HTMLButtonElement>) => {
            onClick(event, asset);
          }}
          sx={{
            borderColor: selectedAsset === asset ? "#99cc33" : null,
          }}
        >
          {formatAssetName(asset)}
        </Button>
      ))}

      {assets.length > 4 ? (
        <Button
          variant="outlined"
          endIcon={<KeyboardArrowDownIcon />}
          onClick={(event: MouseEvent<HTMLButtonElement>) => {
            setAnchorEl(event.currentTarget);
          }}
        >
          See More
        </Button>
      ) : (
        <></>
      )}
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        {assets.slice(4).map((asset: any) => (
          <MenuItem
            selected={selectedAsset === asset}
            onClick={(event: MouseEvent) => {
              onClick(event, asset);
            }}
          >
            {formatAssetName(asset)}
          </MenuItem>
        ))}
      </Menu>
    </Stack>
  );
}
